import { FC } from 'react';

type QuickBuyButtonProps = {
  onBuy: () => void;
  classNames?: string;
  buttonLabel?: string;
};

const QuickBuyButton: FC<QuickBuyButtonProps> = ({ onBuy, classNames, buttonLabel = 'Quick Buy' }) => {
  return (
    <div>
      <button
        className={[
          'button-001 cart-button bldr-cta-button  shadow hover:shadow transition-all  hover:-translate-y-1.5 px-4 py-2 md:py-3 flex flex-row items-center justify-center',
          classNames,
        ].join(' ')}
        onClick={onBuy}
      >
        <span className="text-[13px] md:text-[18px]">{buttonLabel}</span>
      </button>
    </div>
  );
};

export default QuickBuyButton;
